import React from 'react';
import { ChartBarIcon } from '@heroicons/react/24/outline';
import ProgressTracking from '../components/ProgressTracking';

const Progress: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-center mb-8">
        <ChartBarIcon className="w-16 h-16 text-auris-teal mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-auris-dark mb-4">
          Your Progress Dashboard
        </h1>
        <p className="text-gray-600 max-w-3xl mx-auto">
          Comprehensive view of your tinnitus journey. All charts are displayed together to help you 
          identify correlations between your THI scores, tinnitus frequency, and volume measurements over time.
        </p>
      </div>

      <ProgressTracking />

      {/* Additional Information */}
      <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
        <h3 className="font-medium text-blue-900 mb-4">Understanding Your Progress Dashboard</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-blue-800">
          <div>
            <h4 className="font-semibold text-blue-900 mb-2">THI Score Chart</h4>
            <p>
              Lower scores indicate less impact on your daily life. 
              A decreasing trend is generally positive and shows improvement in managing tinnitus.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-blue-900 mb-2">Frequency Chart</h4>
            <p>
              Shows the pitch of your tinnitus over time. 
              Changes in frequency can help identify patterns, triggers, or treatment effects.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-blue-900 mb-2">Volume Chart</h4>
            <p>
              Represents the loudness of your tinnitus in dB. 
              Lower values indicate quieter tinnitus, which is generally positive.
            </p>
          </div>
        </div>
        <div className="mt-4 p-3 bg-blue-100 rounded-lg">
          <p className="text-blue-700 text-sm">
            <strong>💡 Tip:</strong> Look for correlations between the charts. For example, 
            improvements in THI scores might coincide with changes in tinnitus characteristics. 
            Regular assessments help identify long-term trends and treatment effectiveness.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Progress;
